/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  var debugEnabled = /(?:^|&)jabotter_debug=1(?:&|$)/.test(window.location.search.slice(1)) || window.localStorage.getItem('jabotter_debug') === '1';
  function checkoutLog(eventName, details) {
    if (!debugEnabled || !window.console || !console.info) return;
    console.info('[Jabotter checkout]', eventName, details || '');
  }
  var activeConsentPanel = null;
  var activeCheckoutButton = null;
  var consentApproved = false;
  var activeCheckoutHref = null;

  function getConsentPanel(button) {
    var scope = button && button.closest ? button.closest('[data-cart-checkout-buttons], form, body') : document;
    return scope ? scope.querySelector('[data-cart-consent-panel]') : null;
  }

  function getConsentControls() {
    var panel = activeConsentPanel || document.querySelector('[data-cart-consent-panel]:not([hidden])') || document.querySelector('[data-cart-consent-panel]');
    if (!panel) return {};

    return {
      panel: panel,
      checkbox: panel.querySelector('[data-cart-consent-checkbox]'),
      error: panel.querySelector('[data-cart-consent-error]'),
      confirm: panel.querySelector('[data-cart-consent-confirm]'),
    };
  }

  function setConsentAccepted(form) {
    if (!form) return;
    var field = form.querySelector('[data-cart-consent-attribute]');
    if (field) field.value = 'Yes';
  }

  function resetConsentAccepted(form) {
    if (!form) return;
    var field = form.querySelector('[data-cart-consent-attribute]');
    if (field) field.value = '';
  }

  function openConsent(button) {
    var panel = getConsentPanel(button);
    if (!panel) { checkoutLog('consent-panel-missing'); return; }
    checkoutLog('consent-open', { trigger: button && (button.getAttribute('name') || button.className) });
    document.querySelectorAll('[data-cart-consent-panel]').forEach(function(item) {
      if (item !== panel) item.hidden = true;
      item.closest('[data-cart-checkout-button]')?.classList.remove('cart-consent-is-open');
    });
    document.querySelectorAll('[data-cart-open-consent]').forEach(function(item) {
      item.hidden = false;
    });

    activeConsentPanel = panel;
    var controls = getConsentControls();
    if (!controls.panel) return;

    activeCheckoutButton = button;
    activeCheckoutHref = button && button.href ? button.href : null;
    consentApproved = false;
    controls.panel.hidden = false;
    controls.panel.closest('[data-cart-checkout-button]')?.classList.add('cart-consent-is-open');
    if (activeCheckoutButton) activeCheckoutButton.hidden = true;

    if (controls.checkbox) controls.checkbox.checked = false;
    if (controls.error) controls.error.hidden = true;

    window.requestAnimationFrame(function() {
      controls.checkbox && controls.checkbox.focus();
      controls.panel.scrollIntoView({block: 'nearest', behavior: 'smooth'});
    });
  }

  function closeConsent() {
    var controls = getConsentControls();
    if (controls.panel) controls.panel.hidden = true;
    if (controls.panel) controls.panel.closest('[data-cart-checkout-button]')?.classList.remove('cart-consent-is-open');
    if (activeCheckoutButton) activeCheckoutButton.hidden = false;

    activeConsentPanel = null;
    activeCheckoutButton = null;
    activeCheckoutHref = null;
  }

  function isCheckoutTrigger(element) {
    if (!element) return null;
    return element.closest([
      '[data-cart-open-consent]',
      '.cart__checkout',
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href*="/checkout"]',
      'a[href*="/checkouts"]',
      '#mu-checkout-button',
      '.upcart-checkout-button',
      '.checkout-button',
      '.checkout-btn'
    ].join(','));
  }

  function haltCheckoutEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function confirmConsent() {
    var controls = getConsentControls();
    if (!controls.panel || !activeCheckoutButton) { checkoutLog('consent-confirm-missing-state'); return; }

    if (!controls.checkbox || !controls.checkbox.checked) {
      checkoutLog('consent-not-checked');
      if (controls.error) controls.error.hidden = false;
      return;
    }

    if (controls.error) controls.error.hidden = true;

    var form = activeCheckoutButton && activeCheckoutButton.closest ? activeCheckoutButton.closest('form') : null;
    setConsentAccepted(form);
    consentApproved = true;
    checkoutLog('consent-approved');

      var submitButton = activeCheckoutButton;
    var checkoutHref = activeCheckoutHref;
    closeConsent();
    window.setTimeout(function() {
      if (checkoutHref && !submitButton?.closest('form')) {
        checkoutLog('checkout-redirect');
        window.location.href = checkoutHref;
        return;
      }
      if (!submitButton) return;
      var submitForm = submitButton.closest('form');
      if (!submitForm) return;
      var hiddenSubmit = submitForm.querySelector('[data-cart-consent-submit]');
      checkoutLog('checkout-submit', { hasHiddenSubmit: !!hiddenSubmit });
      if (hiddenSubmit && typeof submitForm.requestSubmit === 'function') {
        submitForm.requestSubmit(hiddenSubmit);
      } else if (hiddenSubmit) {
        hiddenSubmit.click();
      } else if (typeof submitForm.requestSubmit === 'function') {
        submitForm.requestSubmit();
      } else {
        submitForm.submit();
      }
    }, 20);
  }

  function checkoutClickHandler(event) {
    var trigger = isCheckoutTrigger(event.target);
    if (trigger) {
      if (consentApproved || trigger.matches('[data-cart-consent-submit]')) return;
      haltCheckoutEvent(event);
      openConsent(trigger);
      return;
    }

    if (event.target.closest('[data-cart-consent-close]')) {
      haltCheckoutEvent(event);
      closeConsent();
      return;
    }

    if (event.target.closest('[data-cart-consent-confirm]')) {
      haltCheckoutEvent(event);
      confirmConsent();
    }
  }

  ['pointerdown', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'click'].forEach(function(eventName) {
    document.addEventListener(eventName, checkoutClickHandler, true);
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeConsent();
    }
  });

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches('[data-cart-form]')) return;

    var checkoutButton = event.submitter || activeCheckoutButton;
    if (!checkoutButton || !checkoutButton.matches('[name="checkout"], [data-cart-consent-submit]')) return;

    var consentField = form.querySelector('[data-cart-consent-attribute]');
    if (!consentField) return;

    if (!consentApproved || consentField.value !== 'Yes') {
      checkoutLog('checkout-blocked', { approved: consentApproved, attribute: consentField.value || 'empty' });
      haltCheckoutEvent(event);
      resetConsentAccepted(form);
      openConsent(checkoutButton);
      return;
    }

    consentApproved = false;
    checkoutLog('checkout-submit-allowed');
  }, true);

  function normalizeTurkishMoneyText(text) {
    // Whole-lira amounts become Turkish style (8,000.00TL -> 8.000 TL); amounts with kurus keep
    // their digits. A match must start at a number boundary, otherwise 36,051.05 was read as "05".
    return text.replace(/(^|[^0-9.,-])(-?)([ ]*)([0-9]{1,3}(?:[.,][0-9]{3})+|[0-9]+)([.,][0-9]{2})?[ ]*TL/g, function(_, lead, sign, gap, amount, decimals) {
      if (decimals && decimals.slice(1) !== '00') return lead + sign + gap + amount + decimals + ' TL';
      return lead + sign + gap + Number(amount.replace(/[.,]/g, '')).toLocaleString('tr-TR') + ' TL';
    });
  }

  function normalizeCartDrawerMoneyText() {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('[data-cart-page]');
    if (!drawer) return;

    drawer.querySelectorAll('.cart__total__price, [data-cart-total]').forEach(function(node) {
      setText(node, normalizeTurkishMoneyText(node.textContent || ''));
    });
  }

  // The drawer observer re-runs this on every mutation, so the write is guarded:
  // a pass that changes nothing emits no mutation records and the loop stops.
  // Without that guard it ran every 180ms forever, forcing layout across the
  // whole drawer and starving input handling on mobile.
  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  var cartTotalSyncTimer = null;
  function scheduleCartTotalSync() {
    window.clearTimeout(cartTotalSyncTimer);
    cartTotalSyncTimer = window.setTimeout(normalizeCartDrawerMoneyText, 180);
  }

  function initMobileSiblingSwatches() {
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth >= 750;
    if (canHover) return;
    window.__jabotterMobileSwatchesReady = true;

    function closestFromEvent(event, selector) {
      if (event.target && event.target.closest) {
        return event.target.closest(selector);
      }

      if (event.composedPath) {
        var path = event.composedPath();
        for (var i = 0; i < path.length; i += 1) {
          if (path[i] && path[i].matches && path[i].matches(selector)) {
            return path[i];
          }
        }
      }

      return null;
    }

    function mobileSwatchHandler(event) {
      var variantSwatchLink = closestFromEvent(event, '[data-swatch-link]');
      var variantSwatch = variantSwatchLink && variantSwatchLink.closest('[data-swatch-button]');
      if (variantSwatch && variantSwatch.hasAttribute('data-swatch-image')) {
        var variantProduct = variantSwatch.closest('[data-grid-item]');
        if (!variantProduct) return;

        var variantHref = variantSwatchLink.getAttribute('href');
        var variantName = variantSwatch.getAttribute('data-swatch-variant-name');
        var variantSelected = variantSwatch.classList.contains('is-touch-selected');
        var currentVariant = variantProduct.querySelector('[data-swatch-button].is-touch-selected');
        if (currentVariant && currentVariant !== variantSwatch) currentVariant.classList.remove('is-touch-selected');

        if (!variantSelected) {
          event.preventDefault();
          event.stopPropagation();
          variantSwatch.classList.add('is-touch-selected');
        }

        variantProduct.classList.add('is-active');
        if (variantHref) {
          variantProduct.querySelectorAll('[data-product-link]').forEach(function(link) {
            link.href = variantHref;
          });
        }

        var variantLayers = variantProduct.querySelectorAll('[data-variant-title]');
        variantLayers.forEach(function(layer) {
          layer.classList.toggle('is-visible', variantName && layer.getAttribute('data-variant-title') === variantName);
        });
        return;
      }

      var swatch = closestFromEvent(event, '[data-sibling-link][data-sibling-image]');
      if (!swatch) return;

      var product = swatch.closest('[data-grid-item]');
      if (!product) return;

      var siblingImage = swatch.getAttribute('data-sibling-image');
      var siblingLink = swatch.getAttribute('data-sibling-link');
      if (!siblingImage || !siblingLink) return;

      var isSelected = swatch.classList.contains('is-touch-selected');
      var current = product.querySelector('[data-sibling-link].is-touch-selected');
      if (current && current !== swatch) current.classList.remove('is-touch-selected');

      if (!isSelected) {
        event.preventDefault();
        event.stopPropagation();
        swatch.classList.add('is-touch-selected');
      }

      product.classList.add('is-active');

      product.querySelectorAll('[data-product-link]').forEach(function(link) {
        link.href = siblingLink;
      });

      var price = swatch.getAttribute('data-sibling-price');
      var priceTarget = product.querySelector('[data-product-price]');
      if (price && priceTarget) priceTarget.innerHTML = '<span class="price">' + price + '</span>';

      var cutline = swatch.getAttribute('data-sibling-cutline');
      var cutlineTarget = product.querySelector('[data-product-cutline]');
      if (cutlineTarget) {
        cutlineTarget.innerHTML = cutline || '';
        cutlineTarget.title = cutline || '';
      }

      var siblingLayer = product.querySelector('[data-product-image-sibling]');
      var defaultImage = product.querySelector('[data-product-image-default] img');
      if (!siblingLayer || !defaultImage) return;

      var targetWidth = Math.max(defaultImage.offsetWidth || 360, 360);
      var sizedImage = siblingImage;
      if (sizedImage.indexOf('width=') === -1) {
        sizedImage += (sizedImage.indexOf('?') === -1 ? '?' : '&') + 'width=' + Math.ceil(targetWidth);
      }

      siblingLayer.innerHTML = '';
      var img = document.createElement('img');
      img.src = sizedImage;
      img.alt = swatch.getAttribute('data-sibling-image-alt') || defaultImage.alt || '';
      img.loading = 'eager';
      img.className = 'is-fade';
      siblingLayer.appendChild(img);
      siblingLayer.classList.add('is-visible');
    }

    ['pointerdown', 'touchstart', 'click'].forEach(function(eventName) {
      document.addEventListener(eventName, mobileSwatchHandler, true);
    });
  }

  function initProductThumbNav() {
    document.querySelectorAll('product-thumbs').forEach(function(thumbs) {
      if (thumbs.dataset.jabotterNavBound) return;

      var holder = thumbs.querySelector('[data-thumbs-slider]');
      var prev = thumbs.querySelector('[data-product-thumbs-prev]');
      var next = thumbs.querySelector('[data-product-thumbs-next]');
      if (!holder || !prev || !next) return;

      thumbs.dataset.jabotterNavBound = 'true';

      function getStep() {
        var item = holder.querySelector('[data-thumb-item]:not([style*="display: none"])') || holder.querySelector('[data-thumb-item]');
        if (!item) return 95;

        var styles = window.getComputedStyle(item);
        return item.offsetHeight + parseFloat(styles.marginBottom || 0) || 95;
      }

      function updateButtons() {
        var vertical = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
        var max = vertical ? holder.scrollHeight - holder.clientHeight : holder.scrollWidth - holder.clientWidth;
        var current = vertical ? holder.scrollTop : holder.scrollLeft;
        var canScroll = max > 4;

        thumbs.classList.toggle('has-thumb-overflow', canScroll);
        prev.disabled = !canScroll || current <= 4;
        next.disabled = !canScroll || current >= max - 4;
      }

      function animateThumbScroll(vertical, target) {
        var start = vertical ? holder.scrollTop : holder.scrollLeft;
        var max = vertical ? holder.scrollHeight - holder.clientHeight : holder.scrollWidth - holder.clientWidth;
        var end = Math.max(0, Math.min(target, max));
        var distance = end - start;
        var duration = 900;
        var startedAt = window.performance.now();

        function ease(t) {
          return 1 - Math.pow(1 - t, 3);
        }

        function step(now) {
          var progress = Math.min((now - startedAt) / duration, 1);
          var value = start + distance * ease(progress);

          if (vertical) {
            holder.scrollTop = value;
          } else {
            holder.scrollLeft = value;
          }

          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            updateButtons();
          }
        }

        window.requestAnimationFrame(step);
      }

      function scrollBy(direction) {
        var vertical = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
        var distance = getStep() * direction;
        var current = vertical ? holder.scrollTop : holder.scrollLeft;

        animateThumbScroll(vertical, current + distance);
      }

      var autoplayTimer = null;
      var thumbAutoplayKickTimer = null;
      var thumbAutoplayPaused = false;
      var thumbAutoplayStoppedByUser = false;

      function stopThumbAutoplay(stoppedByUser) {
        if (stoppedByUser) thumbAutoplayStoppedByUser = true;
        window.clearInterval(autoplayTimer);
        window.clearTimeout(thumbAutoplayKickTimer);
        autoplayTimer = null;
        thumbAutoplayKickTimer = null;
      }

      function canAutoplayThumbs() {
        var vertical = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
        var max = vertical ? holder.scrollHeight - holder.clientHeight : holder.scrollWidth - holder.clientWidth;
        return max > 4;
      }

      function autoplayThumbs() {
        var vertical = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
        var max = vertical ? holder.scrollHeight - holder.clientHeight : holder.scrollWidth - holder.clientWidth;
        if (max <= 4) return;

        var current = vertical ? holder.scrollTop : holder.scrollLeft;
        var nextPosition = current + getStep();

        if (nextPosition >= max - 4) {
          nextPosition = 0;
        }

        animateThumbScroll(vertical, nextPosition);
      }

      function startThumbAutoplay() {
        if (thumbAutoplayStoppedByUser || thumbAutoplayPaused) return;
        window.clearInterval(autoplayTimer);
        window.clearTimeout(thumbAutoplayKickTimer);

        var attempts = 0;
        function kickAutoplay() {
          thumbAutoplayKickTimer = null;
          if (thumbAutoplayStoppedByUser || thumbAutoplayPaused) return;

          updateButtons();
          if (canAutoplayThumbs()) {
            autoplayThumbs();
            return;
          }

          attempts += 1;
          if (attempts < 8) {
            thumbAutoplayKickTimer = window.setTimeout(kickAutoplay, 500);
          }
        }

        thumbAutoplayKickTimer = window.setTimeout(kickAutoplay, 700);
        autoplayTimer = window.setInterval(autoplayThumbs, 4200);
      }

      var mainAutoplayTimer = null;

      function stopMainAutoplay() {
        window.clearInterval(mainAutoplayTimer);
        mainAutoplayTimer = null;
      }

      function getVisibleThumbLinks() {
        return Array.prototype.filter.call(holder.querySelectorAll('[data-thumb-link]'), function(link) {
          var item = link.closest('[data-thumb-item]');
          return item && item.style.display !== 'none';
        });
      }

      function autoplayMainImage() {
        var productImages = thumbs.closest('[data-product]') && thumbs.closest('[data-product]').querySelector('product-images[data-active-media]');
        var links = getVisibleThumbLinks();

        if (!productImages || links.length <= 1) return;

        var activeId = productImages.getAttribute('data-active-media');
        var activeIndex = links.findIndex(function(link) {
          return link.getAttribute('data-media-id') === activeId;
        });
        var nextLink = links[(activeIndex + 1 + links.length) % links.length];
        var nextId = nextLink && nextLink.getAttribute('data-media-id');

        if (!nextId) return;

        thumbs.dispatchEvent(new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: { id: nextId },
        }));
      }

      function startMainAutoplay() {
        window.clearInterval(mainAutoplayTimer);
        mainAutoplayTimer = window.setInterval(autoplayMainImage, 5200);
      }

      function syncThumbsWithPageScroll() {
        if (!window.matchMedia || !window.matchMedia('(min-width: 750px)').matches) return;

        var max = holder.scrollHeight - holder.clientHeight;
        if (max <= 4) return;

        var product = thumbs.closest('[data-product]') || thumbs.closest('.product__page');
        if (!product) return;

        var rect = product.getBoundingClientRect();
        var scrollable = Math.max(rect.height - window.innerHeight, 1);
        var progress = Math.min(Math.max((0 - rect.top) / scrollable, 0), 1);
        var target = max * progress;

        holder.scrollTop += (target - holder.scrollTop) * 0.08;
        updateButtons();
      }

      var scrollSyncFrame = null;

      function requestThumbScrollSync() {
        if (scrollSyncFrame) return;

        scrollSyncFrame = window.requestAnimationFrame(function() {
          scrollSyncFrame = null;
          syncThumbsWithPageScroll();
        });
      }

      prev.addEventListener('click', function() {
        stopThumbAutoplay(true);
        stopMainAutoplay();
        scrollBy(-1);
      });

      next.addEventListener('click', function() {
        stopThumbAutoplay(true);
        stopMainAutoplay();
        scrollBy(1);
      });

      holder.addEventListener('click', stopMainAutoplay);
      thumbs.addEventListener('mouseenter', function() {
        thumbAutoplayPaused = true;
        stopThumbAutoplay(false);
      });
      thumbs.addEventListener('mouseleave', function() {
        thumbAutoplayPaused = false;
        startThumbAutoplay();
      });
      holder.addEventListener('pointerdown', function() {
        stopThumbAutoplay(true);
        stopMainAutoplay();
      });
      holder.addEventListener('touchstart', function() {
        stopThumbAutoplay(true);
        stopMainAutoplay();
      }, { passive: true });
      holder.addEventListener('wheel', function() {
        stopThumbAutoplay(true);
        stopMainAutoplay();
      }, { passive: true });
      holder.addEventListener('keydown', function() {
        stopThumbAutoplay(true);
        stopMainAutoplay();
      });
      holder.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('scroll', requestThumbScrollSync, { passive: true });
      window.addEventListener('resize', updateButtons);
      new MutationObserver(function() {
        window.requestAnimationFrame(function() {
          updateButtons();
          startThumbAutoplay();
        });
      }).observe(holder, { attributes: true, childList: true, subtree: true, attributeFilter: ['style', 'class'] });

      if (document.readyState !== 'loading') {
        window.requestAnimationFrame(function() {
          updateButtons();
          startThumbAutoplay();
          startMainAutoplay();
        });
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          updateButtons();
          startThumbAutoplay();
          startMainAutoplay();
        });
      }
    });
  }

  function initInlineColorRecommendations() {
    document.querySelectorAll('[data-jabotter-inline-color-products]').forEach(function(block) {
      if (block.dataset.jabotterColorBound) return;

      var product = block.closest('[data-product]') || document;
      var heading = block.querySelector('[data-jabotter-inline-color-heading]');
      var grid = block.querySelector('.jabotter-inline-color-products__grid');
      var items = Array.prototype.slice.call(block.querySelectorAll('[data-jabotter-inline-color-item]'));
      if (!items.length) return;

      block.dataset.jabotterColorBound = 'true';

      function normalizeColor(value) {
        return (value || '')
          .toString()
          .trim()
          .toLocaleLowerCase('tr-TR')
          .replace(/ı/g, 'i')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      var colorCombinationRules = {
        sari: ['sari', 'siyah', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'ten', 'gri', 'gumus', 'kahverengi', 'taba', 'camel', 'lacivert', 'mavi', 'denim', 'kot', 'yesil', 'zeytin', 'haki', 'mor', 'lila', 'lavanta'],
        gold: ['gold', 'altin', 'sari', 'siyah', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'kahverengi', 'taba', 'bordo', 'zümrüt', 'zumrut', 'lacivert'],
        siyah: ['siyah', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'gri', 'gumus', 'gold', 'altin', 'kirmizi', 'bordo', 'pembe', 'fuşya', 'fusya', 'yesil', 'lacivert', 'mavi'],
        beyaz: ['beyaz', 'ekru', 'krem', 'siyah', 'bej', 'nude', 'ten', 'taba', 'kahverengi', 'gri', 'gumus', 'lacivert', 'mavi', 'pembe', 'yesil', 'sari'],
        ekru: ['ekru', 'krem', 'beyaz', 'bej', 'nude', 'ten', 'taba', 'kahverengi', 'siyah', 'gold', 'altin', 'lacivert', 'yesil', 'bordo'],
        krem: ['krem', 'ekru', 'beyaz', 'bej', 'nude', 'ten', 'taba', 'kahverengi', 'siyah', 'gold', 'altin', 'lacivert', 'yesil', 'bordo'],
        bej: ['bej', 'nude', 'ten', 'krem', 'ekru', 'beyaz', 'taba', 'kahverengi', 'siyah', 'gold', 'altin', 'lacivert', 'mavi', 'yesil', 'sari'],
        nude: ['nude', 'ten', 'bej', 'krem', 'ekru', 'beyaz', 'taba', 'kahverengi', 'siyah', 'gold', 'altin', 'pembe', 'bordo'],
        kahverengi: ['kahverengi', 'taba', 'camel', 'bej', 'nude', 'ten', 'krem', 'ekru', 'beyaz', 'sari', 'yesil', 'haki', 'turuncu', 'gold', 'altin'],
        taba: ['taba', 'camel', 'kahverengi', 'bej', 'nude', 'ten', 'krem', 'ekru', 'beyaz', 'sari', 'yesil', 'haki', 'gold', 'altin'],
        gri: ['gri', 'gumus', 'siyah', 'beyaz', 'ekru', 'krem', 'pembe', 'sari', 'mavi', 'lacivert', 'mor', 'lila'],
        gumus: ['gumus', 'gri', 'siyah', 'beyaz', 'ekru', 'krem', 'mavi', 'lacivert', 'pembe', 'mor', 'lila'],
        lacivert: ['lacivert', 'mavi', 'denim', 'kot', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'sari', 'taba', 'kahverengi', 'gri', 'gumus', 'pembe'],
        mavi: ['mavi', 'lacivert', 'denim', 'kot', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'sari', 'taba', 'kahverengi', 'gri', 'pembe', 'turuncu'],
        yesil: ['yesil', 'haki', 'zeytin', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'taba', 'kahverengi', 'sari', 'gold', 'altin', 'siyah', 'pembe'],
        haki: ['haki', 'zeytin', 'yesil', 'bej', 'nude', 'krem', 'ekru', 'taba', 'kahverengi', 'sari', 'siyah', 'gold', 'altin'],
        pembe: ['pembe', 'pudra', 'fuşya', 'fusya', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'gri', 'gumus', 'siyah', 'lacivert', 'yesil', 'kirmizi'],
        pudra: ['pudra', 'pembe', 'bej', 'nude', 'krem', 'ekru', 'beyaz', 'gri', 'gumus', 'siyah', 'lacivert'],
        kirmizi: ['kirmizi', 'bordo', 'siyah', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'denim', 'mavi', 'lacivert', 'pembe', 'gold', 'altin'],
        bordo: ['bordo', 'kirmizi', 'siyah', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'gri', 'gumus', 'gold', 'altin', 'lacivert'],
        mor: ['mor', 'lila', 'lavanta', 'sari', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'gri', 'gumus', 'siyah', 'yesil'],
        lila: ['lila', 'lavanta', 'mor', 'sari', 'beyaz', 'ekru', 'krem', 'bej', 'nude', 'gri', 'gumus', 'siyah'],
        turuncu: ['turuncu', 'taba', 'kahverengi', 'bej', 'nude', 'krem', 'ekru', 'beyaz', 'mavi', 'lacivert', 'yesil', 'gold', 'altin'],
      };

      function getCompatibleColorHandles(colorHandle) {
        return colorCombinationRules[colorHandle] || (colorHandle ? [colorHandle] : []);
      }

      function normalizeColorFamily(colorHandle) {
        colorHandle = normalizeColor(colorHandle);
        if (!colorHandle) return '';
        if (/^(?:3[4-9]|4[0-2]|1[2-8]|stn)$/.test(colorHandle)) return '';
        if (colorHandle.indexOf('dore') !== -1 || colorHandle.indexOf('altin') !== -1 || colorHandle.indexOf('gold') !== -1) return 'gold';
        if (colorHandle.indexOf('lame') !== -1 || colorHandle.indexOf('gumus') !== -1 || colorHandle.indexOf('silver') !== -1) return 'gumus';
        if (colorHandle.indexOf('siyah') !== -1) return 'siyah';
        if (colorHandle.indexOf('beyaz') !== -1 || colorHandle.indexOf('ekru') !== -1 || colorHandle.indexOf('krem') !== -1) return 'ekru';
        if (colorHandle.indexOf('bej') !== -1 || colorHandle.indexOf('nude') !== -1 || colorHandle.indexOf('ten') !== -1) return 'bej';
        if (colorHandle.indexOf('taba') !== -1 || colorHandle.indexOf('kahve') !== -1 || colorHandle.indexOf('karamel') !== -1 || colorHandle.indexOf('camel') !== -1 || colorHandle.indexOf('vizon') !== -1 || colorHandle.indexOf('taupe') !== -1) return 'taba';
        if (colorHandle.indexOf('bordo') !== -1 || colorHandle.indexOf('kirmizi') !== -1) return 'bordo';
        if (colorHandle.indexOf('lacivert') !== -1 || colorHandle.indexOf('mavi') !== -1) return 'lacivert';
        if (colorHandle.indexOf('yesil') !== -1 || colorHandle.indexOf('haki') !== -1 || colorHandle.indexOf('avokado') !== -1 || colorHandle.indexOf('petrol') !== -1) return 'yesil';
        if (colorHandle.indexOf('pembe') !== -1 || colorHandle.indexOf('pudra') !== -1 || colorHandle.indexOf('fusya') !== -1) return 'pembe';
        if (colorHandle.indexOf('sari') !== -1) return 'sari';
        if (colorHandle.indexOf('gri') !== -1 || colorHandle.indexOf('fume') !== -1) return 'gri';
        return colorHandle;
      }

      function expandColorFamilies(handles) {
        return handles.map(normalizeColorFamily).filter(Boolean);
      }

      function firstMatchingHandle(handles, allowedHandles) {
        for (var i = 0; i < allowedHandles.length; i += 1) {
          if (handles.indexOf(allowedHandles[i]) !== -1) return allowedHandles[i];
        }

        return null;
      }

      function firstMatchingActualHandle(handles, allowedHandles) {
        var allowed = allowedHandles.filter(Boolean);
        var requestedHandle = allowed[0] || '';

        if (requestedHandle.indexOf('-') !== -1) {
          for (var requestedIndex = 0; requestedIndex < handles.length; requestedIndex += 1) {
            var requestedPart = handles[requestedIndex];

            if (
              requestedPart &&
              requestedPart.length > 3 &&
              requestedHandle !== requestedPart &&
              (
                requestedHandle.indexOf(requestedPart + '-') === 0 ||
                requestedHandle.indexOf('-' + requestedPart) !== -1
              )
            ) {
              return requestedPart;
            }
          }
        }

        for (var exactIndex = 0; exactIndex < allowed.length; exactIndex += 1) {
          if (handles.indexOf(allowed[exactIndex]) !== -1) return allowed[exactIndex];
        }

        for (var containsIndex = 0; containsIndex < handles.length; containsIndex += 1) {
          var containingHandle = handles[containsIndex];

          for (var allowedIndex = 0; allowedIndex < allowed.length; allowedIndex += 1) {
            var allowedHandle = allowed[allowedIndex];
            if (
              containingHandle.indexOf(allowedHandle + '-') === 0 ||
              containingHandle.indexOf('-' + allowedHandle) !== -1
            ) {
              return containingHandle;
            }
          }
        }

        for (var i = 0; i < handles.length; i += 1) {
          var handle = handles[i];
          var family = normalizeColorFamily(handle);

          if (allowed.indexOf(handle) !== -1 || allowed.indexOf(family) !== -1) return handle;
        }

        return null;
      }

      function itemHasSelectedColorVariant(item, selectedColorHandle) {
        var handles = (item.getAttribute('data-color-handles') || '').split(/\s+/).map(normalizeColor).filter(Boolean);
        if (!selectedColorHandle) return true;
        if (handles.indexOf(selectedColorHandle) !== -1) return true;

        if (selectedColorHandle.indexOf('-') !== -1) {
          for (var i = 0; i < handles.length; i += 1) {
            var handle = handles[i];

            if (
              handle &&
              handle.length > 3 &&
              handle !== selectedColorHandle &&
              (
                selectedColorHandle.indexOf(handle + '-') === 0 ||
                selectedColorHandle.indexOf('-' + handle) !== -1
              )
            ) return true;
          }
        }

        return false;
      }

      function getItemColorSignals(item) {
        var handles = (item.getAttribute('data-color-handles') || '').split(/\s+/).filter(Boolean);
        var title = normalizeColor(item.getAttribute('data-product-title') || '');
        var text = handles.concat([title]).join(' ');
        var signals = handles.concat(expandColorFamilies(handles));
        var knownSignals = {
          siyah: ['siyah', 'black'],
          ekru: ['beyaz', 'white', 'ekru', 'krem', 'cream'],
          bej: ['bej', 'beige', 'nude', 'ten'],
          taba: ['taba', 'kahve', 'kahverengi', 'brown', 'karamel', 'camel'],
          bordo: ['bordo', 'kirmizi', 'red', 'burgundy'],
          lacivert: ['lacivert', 'navy', 'mavi', 'blue'],
          sari: ['sari', 'yellow'],
          yesil: ['yesil', 'green', 'haki'],
          pembe: ['pembe', 'pink', 'pudra', 'fusya'],
          mor: ['mor', 'purple', 'royal-purple', 'lila', 'lavanta'],
          gri: ['gri', 'grey', 'gray', 'fume'],
          gumus: ['gumus', 'silver', 'lame'],
          gold: ['gold', 'altin', 'dore'],
        };

        Object.keys(knownSignals).forEach(function(signal) {
          if (signals.indexOf(signal) !== -1) return;

          if (knownSignals[signal].some(function(token) {
            return text.indexOf(token) !== -1;
          })) {
            signals.push(signal);
          }
        });

        return signals.filter(Boolean);
      }

      function itemHasColorAffinity(item, allowedHandles) {
        var signals = getItemColorSignals(item);
        return !!firstMatchingHandle(signals, allowedHandles);
      }

      function itemHasJewelryColorAffinity(item, allowedHandles, selectedColorHandle) {
        var signals = getItemColorSignals(item);
        var selectedFamily = normalizeColorFamily(selectedColorHandle || '');
        var decorativeSignals = signals.filter(function(signal) {
          return ['gumus', 'gold', 'altin', 'lame', 'stn'].indexOf(signal) === -1 &&
            !/^\d+$/.test(signal) &&
            !/(?:ayar|gumus|gümüş|silver|jewellery|jewelry|yuzuk|yüzük|kupe|küpe|bileklik|kolye)/.test(signal);
        });

        if (decorativeSignals.length) return !!firstMatchingHandle(decorativeSignals, allowedHandles);

        if (selectedFamily === 'gumus' || selectedFamily === 'gold') return !!firstMatchingHandle(signals, allowedHandles);

        return false;
      }

      function productTypeIncludes(type, terms) {
        return terms.some(function(term) {
          return type.indexOf(term) !== -1;
        });
      }

      function getSiblingColorHandles(colorHandle) {
        var siblings = {
          sari: ['sari', 'gold', 'altin'],
          gold: ['gold', 'altin', 'sari'],
          altin: ['altin', 'gold', 'sari'],
          siyah: ['siyah'],
          beyaz: ['beyaz', 'ekru', 'krem'],
          ekru: ['ekru', 'krem', 'beyaz', 'bej'],
          krem: ['krem', 'ekru', 'beyaz', 'bej'],
          bej: ['bej', 'nude', 'ten', 'krem', 'ekru'],
          nude: ['nude', 'ten', 'bej'],
          ten: ['ten', 'nude', 'bej'],
          kahverengi: ['kahverengi', 'taba', 'camel'],
          taba: ['taba', 'camel', 'kahverengi'],
          camel: ['camel', 'taba', 'kahverengi'],
          gri: ['gri', 'gumus'],
          gumus: ['gumus', 'gri'],
          lacivert: ['lacivert', 'mavi', 'denim', 'kot'],
          mavi: ['mavi', 'lacivert', 'denim', 'kot'],
          yesil: ['yesil', 'haki', 'zeytin'],
          haki: ['haki', 'zeytin', 'yesil'],
          zeytin: ['zeytin', 'haki', 'yesil'],
          pembe: ['pembe', 'pudra', 'fuşya', 'fusya'],
          pudra: ['pudra', 'pembe'],
          kirmizi: ['kirmizi', 'bordo'],
          bordo: ['bordo', 'kirmizi'],
          mor: ['mor', 'lila', 'lavanta'],
          lila: ['lila', 'lavanta', 'mor'],
          turuncu: ['turuncu', 'taba', 'camel'],
        };

        return siblings[colorHandle] || (colorHandle ? [colorHandle] : []);
      }

      var colorHeadingLabels = {
        sari: 'İlginizi çekebileceğini düşündüğümüz ürünler',
        gold: 'İlginizi çekebileceğini düşündüğümüz ürünler',
        altin: 'İlginizi çekebileceğini düşündüğümüz ürünler',
      };

      function getTypeRole(type) {
        var value = type || '';
        if (productTypeIncludes(value, ['jewellery', 'jewelry', 'mucevher', 'mücevher', 'yuzuk', 'yüzük', 'kupe', 'küpe', 'bileklik', 'kolye'])) return 'jewelry';
        if (productTypeIncludes(value, ['canta', 'çanta', 'bag'])) return 'bag';
        if (productTypeIncludes(value, ['ayakkabi', 'ayakkabı', 'stiletto', 'terlik', 'sandalet', 'bot', 'cizme', 'çizme', 'shoe', 'boot'])) return 'shoe';
        if (productTypeIncludes(value, ['gomlek', 'gömlek', 'bluz', 'bustiyer', 'büstiyer', 'ceket', 'yelek', 'ust', 'üst', 'top'])) return 'top';
        if (productTypeIncludes(value, ['pantolon', 'etek', 'sort', 'şort', 'bottom', 'alt-giyim'])) return 'bottom';
        if (productTypeIncludes(value, ['elbise', 'dress'])) return 'dress';
        return 'other';
      }

      function getRoleFromItem(item) {
        return getTypeRole([
          item.getAttribute('data-product-type') || '',
          item.getAttribute('data-season-text') || '',
          normalizeColor(item.getAttribute('data-product-title') || ''),
        ].join(' '));
      }

      function getCurrentRole(item) {
        return getTypeRole([
          item.getAttribute('data-current-product-type') || '',
          item.getAttribute('data-current-season-text') || '',
          normalizeColor(block.getAttribute('data-product-title') || ''),
        ].join(' '));
      }

      function hasMaterialMatch(item) {
        var currentText = [
          item.getAttribute('data-current-season-text') || '',
          normalizeColor(block.getAttribute('data-product-title') || ''),
        ].join(' ');
        var itemText = [
          item.getAttribute('data-season-text') || '',
          normalizeColor(item.getAttribute('data-product-title') || ''),
        ].join(' ');
        var materials = ['suet', 'süet', 'deri', 'saten', 'rugan', 'simli', 'tasli', 'taşlı', 'seffaf', 'şeffaf'];

        return materials.some(function(material) {
          return currentText.indexOf(material) !== -1 && itemText.indexOf(material) !== -1;
        });
      }

      function getComplementScore(item, colorHandle, compatibleHandles, siblingHandles) {
        var handles = (item.getAttribute('data-color-handles') || '').split(/\s+/);
        var familyHandles = expandColorFamilies(handles);
        var currentType = item.getAttribute('data-current-product-type') || '';
        var itemType = item.getAttribute('data-product-type') || '';
        var currentRole = getCurrentRole(item);
        var itemRole = getRoleFromItem(item);
        var sameType = itemType === currentType;
        var compatibleMatch = firstMatchingHandle(handles, compatibleHandles) || firstMatchingHandle(familyHandles, compatibleHandles);
        var siblingMatch = firstMatchingHandle(handles, siblingHandles) || firstMatchingHandle(familyHandles, siblingHandles);
        var jewelryColorAffinity = itemRole !== 'jewelry' || itemHasJewelryColorAffinity(item, compatibleHandles.concat(siblingHandles), colorHandle);
        var score = 0;

        if (compatibleMatch) score += 40;
        if (siblingMatch) score += 18;
        if (colorHandle && (handles.indexOf(colorHandle) !== -1 || familyHandles.indexOf(normalizeColorFamily(colorHandle)) !== -1)) score += 12;
        if (hasMaterialMatch(item)) score += 16;
        if (!sameType) score += 14;
        if ((currentRole === 'bag' && itemRole === 'shoe') || (currentRole === 'shoe' && itemRole === 'bag')) score += 34;
        if ((currentRole === 'bag' && itemRole === 'jewelry') || (currentRole === 'shoe' && itemRole === 'jewelry')) score += jewelryColorAffinity ? 18 : -26;
        if (currentRole === 'shoe' && (itemRole === 'dress' || itemRole === 'top' || itemRole === 'bottom')) score += 24;
        if (currentRole === 'bag' && (itemRole === 'dress' || itemRole === 'top' || itemRole === 'bottom')) score += 20;
        if ((currentRole === 'top' && itemRole === 'bottom') || (currentRole === 'bottom' && itemRole === 'top')) score += 30;
        if (currentRole === 'dress' && (itemRole === 'shoe' || itemRole === 'bag' || itemRole === 'jewelry')) score += itemRole === 'jewelry' && !jewelryColorAffinity ? 0 : 28;
        if (sameType && siblingMatch) score += 6;
        if (itemRole === 'jewelry') score += jewelryColorAffinity ? -6 : -42;
        if (itemRole === 'other') score -= 18;

        return score;
      }

      function getSlotPlan(currentRole, maxRecommendations, categoryMix) {
        if (categoryMix === 'off') return {similar: maxRecommendations, complete: maxRecommendations};

        if (categoryMix === 'similar') {
          if (currentRole === 'shoe') return {similar: Math.min(4, maxRecommendations), bag: 1, jewelry: 1, complete: maxRecommendations};
          if (currentRole === 'bag') return {similar: Math.min(4, maxRecommendations), shoe: 1, jewelry: 1, complete: maxRecommendations};
          if (currentRole === 'jewelry') return {similar: Math.min(4, maxRecommendations), bag: 1, shoe: 1, complete: maxRecommendations};
          return {similar: Math.min(4, maxRecommendations), shoe: 1, bag: 1, complete: maxRecommendations};
        }

        if (categoryMix === 'outfit') {
          if (currentRole === 'shoe') return {similar: 1, bag: 1, jewelry: 1, dress: 1, top: 1, bottom: 1, complete: maxRecommendations};
          if (currentRole === 'bag') return {similar: 1, shoe: 1, jewelry: 1, dress: 1, top: 1, bottom: 1, complete: maxRecommendations};
          if (currentRole === 'top' || currentRole === 'bottom' || currentRole === 'dress') return {similar: 1, shoe: 1, bag: 1, jewelry: 1, top: 1, bottom: 1, dress: 1, complete: maxRecommendations};
          if (currentRole === 'jewelry') return {similar: 1, bag: 1, shoe: 1, dress: 1, top: 1, bottom: 1, complete: maxRecommendations};
        }

        if (currentRole === 'shoe') return {similar: Math.min(2, maxRecommendations), bag: 2, dress: 1, top: 1, bottom: 1, jewelry: Math.max(1, Math.floor(maxRecommendations / 5)), complete: maxRecommendations};
        if (currentRole === 'bag') return {similar: Math.min(2, maxRecommendations), shoe: 2, dress: 1, top: 1, bottom: 1, jewelry: Math.max(1, Math.floor(maxRecommendations / 5)), complete: maxRecommendations};
        if (currentRole === 'top' || currentRole === 'bottom' || currentRole === 'dress') return {similar: 2, shoe: 2, bag: 2, jewelry: 1, complete: maxRecommendations};
        if (currentRole === 'jewelry') return {similar: 3, bag: 1, shoe: 1, complete: maxRecommendations};
        return {similar: Math.ceil(maxRecommendations / 2), complete: maxRecommendations};
      }

      function getRoleLimit(role, currentRole, categoryMix, maxRecommendations) {
        if (categoryMix === 'off') return maxRecommendations;
        if (categoryMix === 'similar') {
          if (role === currentRole) return Math.min(4, maxRecommendations);
          if (role === 'bag' || role === 'shoe') return 2;
          if (role === 'jewelry') return 1;
          return 1;
        }
        if (categoryMix === 'outfit') {
          if (role === 'bag' || role === 'shoe') return 2;
          if (role === 'jewelry') return 1;
          if (role === 'dress' || role === 'top' || role === 'bottom') return 1;
          return 1;
        }
        if (role === 'bag' || role === 'shoe') return 2;
        if (role === 'jewelry') return 1;
        if (role === 'dress' || role === 'top' || role === 'bottom') return 1;
        return Math.min(2, maxRecommendations);
      }

      function getRoleGroup(role) {
        if (role === 'dress' || role === 'top' || role === 'bottom') return 'apparel';
        return role;
      }

      function getGroupLimit(group, categoryMix, maxRecommendations) {
        if (categoryMix === 'off') return maxRecommendations;
        if (categoryMix === 'similar') {
          if (group === 'apparel' || group === 'jewelry') return 1;
          if (group === 'bag' || group === 'shoe') return 2;
          return 1;
        }
        if (categoryMix === 'outfit') {
          if (group === 'apparel') return 1;
          if (group === 'jewelry') return 1;
          if (group === 'bag' || group === 'shoe') return 2;
          return 1;
        }
        if (group === 'apparel' || group === 'jewelry') return 1;
        if (group === 'bag' || group === 'shoe') return 2;
        return Math.min(2, maxRecommendations);
      }

      function getSelectedColor() {
        var selected = null;

        product.querySelectorAll('[data-single-option-selector]:checked, [data-single-option-selector][type="hidden"]').forEach(function(input) {
          if (selected) return;

          var fieldset = input.closest('fieldset');
          var legend = fieldset && fieldset.querySelector('.radio__legend__option-name');
          var name = ((legend && legend.textContent) || input.name || '').toLocaleLowerCase('tr-TR');

          if (name.indexOf('renk') !== -1 || name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) {
            selected = input.value;
          }
        });

        return selected;
      }

      function getVariantLink(item, colorHandle) {
        var links = (item.getAttribute('data-variant-links') || '').split('||');
        var fallback = item.href;
        var colorFamily = normalizeColorFamily(colorHandle);

        for (var i = 0; i < links.length; i += 1) {
          var pair = links[i].split('::');
          if (normalizeColor(pair[0]) === normalizeColor(colorHandle) && pair[1]) return pair[1];
        }

        for (var j = 0; j < links.length; j += 1) {
          var familyPair = links[j].split('::');
          if (normalizeColorFamily(familyPair[0]) === colorFamily && familyPair[1]) return familyPair[1];
        }

        return fallback;
      }

      function updateRecommendations() {
        var maxRecommendations = parseInt(block.getAttribute('data-max-products'), 10) || 6;
        var recommendationMode = block.getAttribute('data-recommendation-mode') || 'smart';
        var categoryMix = block.getAttribute('data-category-mix') || 'outfit';
        var avoidSeasonMismatch = block.getAttribute('data-avoid-season-mismatch') !== 'false';
        var customHeading = block.getAttribute('data-custom-heading') || '';
        var color = getSelectedColor();
        var selectedColorHandle = normalizeColor(color);
        var colorHandle = normalizeColorFamily(selectedColorHandle) || selectedColorHandle;
        var compatibleHandles = getCompatibleColorHandles(colorHandle);
        var siblingHandles = getSiblingColorHandles(colorHandle);
        var selectedItems = [];
        var similarItems = [];
        var completeItems = [];
        var candidateLimit = items.length;
        var exactVisible = 0;
        var compatibleVisible = 0;

        function isSeasonCompatible(item) {
          var currentText = [
            item.getAttribute('data-current-product-type') || '',
            item.getAttribute('data-current-season-text') || '',
          ].join(' ');
          var itemText = [
            item.getAttribute('data-product-type') || '',
            item.getAttribute('data-season-text') || '',
          ].join(' ');
          var currentIsWinter = productTypeIncludes(currentText, ['bot', 'cizme', 'boot', 'winter', 'kis', 'kış']);
          var itemIsWinter = productTypeIncludes(itemText, ['bot', 'cizme', 'boot', 'winter', 'kis', 'kış']);

          return currentIsWinter || !itemIsWinter;
        }

        function addCandidates(allowItem) {
          items.forEach(function(item) {
            var itemRole = getRoleFromItem(item);

            if (selectedItems.length >= candidateLimit || selectedItems.indexOf(item) !== -1) return;
            if (avoidSeasonMismatch && !isSeasonCompatible(item)) return;
            if (colorHandle && !itemHasSelectedColorVariant(item, selectedColorHandle)) return;
            if (
              itemRole === 'jewelry' &&
              getCurrentRole(item) !== 'jewelry' &&
              !itemHasJewelryColorAffinity(item, compatibleHandles.concat(siblingHandles), colorHandle)
            ) return;
            if (!allowItem(item)) return;

            selectedItems.push(item);
          });
        }

        function sortByStylingScore() {
          selectedItems.sort(function(a, b) {
            return getComplementScore(b, colorHandle, compatibleHandles, siblingHandles) - getComplementScore(a, colorHandle, compatibleHandles, siblingHandles);
          });
        }

        function pickBySlots() {
          if (!selectedItems.length) return;

          var currentRole = getCurrentRole(selectedItems[0]);
          var plan = getSlotPlan(currentRole, maxRecommendations, categoryMix);
          var sorted = selectedItems.slice().sort(function(a, b) {
            return getComplementScore(b, colorHandle, compatibleHandles, siblingHandles) - getComplementScore(a, colorHandle, compatibleHandles, siblingHandles);
          });
          var picked = [];
          var completePicked = [];
          var roleCounts = {};
          var groupCounts = {};

          function canAddRole(role) {
            var group = getRoleGroup(role);
            roleCounts[role] = roleCounts[role] || 0;
            groupCounts[group] = groupCounts[group] || 0;
            return roleCounts[role] < getRoleLimit(role, currentRole, categoryMix, maxRecommendations) &&
              groupCounts[group] < getGroupLimit(group, categoryMix, maxRecommendations);
          }

          function canUseItemForRole(item, role) {
            if (role !== 'jewelry' || currentRole === 'jewelry') return true;
            return itemHasJewelryColorAffinity(item, compatibleHandles.concat(siblingHandles), colorHandle);
          }

          function markRole(role) {
            var group = getRoleGroup(role);
            roleCounts[role] = (roleCounts[role] || 0) + 1;
            groupCounts[group] = (groupCounts[group] || 0) + 1;
          }

          function addFromRole(role, limit, target) {
            sorted.forEach(function(item) {
              if (picked.length >= maxRecommendations || target.length >= limit || picked.indexOf(item) !== -1) return;
              if (getRoleFromItem(item) !== role) return;
              if (!canAddRole(role)) return;
              if (!canUseItemForRole(item, role)) return;
              picked.push(item);
              markRole(role);
              target.push(item);
            });
          }

          function addFromRoles(roles, limit, target) {
            sorted.forEach(function(item) {
              var itemRole = getRoleFromItem(item);
              if (picked.length >= maxRecommendations || target.length >= limit || picked.indexOf(item) !== -1) return;
              if (roles.indexOf(itemRole) === -1) return;
              if (!canAddRole(itemRole)) return;
              if (!canUseItemForRole(item, itemRole)) return;
              picked.push(item);
              markRole(itemRole);
              target.push(item);
            });
          }

          addFromRole(currentRole, plan.similar || 0, similarItems);

          if (categoryMix === 'outfit') {
            addFromRole('bag', plan.bag || 0, completePicked);
            addFromRole('shoe', plan.shoe || 0, completePicked);
            addFromRole('jewelry', plan.jewelry || 0, completePicked);
            addFromRoles(['dress', 'top', 'bottom'], Math.max(plan.dress || 0, plan.top || 0, plan.bottom || 0), completePicked);
          }

          ['bag', 'shoe', 'dress', 'top', 'bottom', 'jewelry'].forEach(function(role) {
            var limit = plan[role] || 0;
            if (!limit) return;
            addFromRole(role, limit, completePicked);
          });

          sorted.forEach(function(item) {
            var itemRole = getRoleFromItem(item);
            if (picked.length >= maxRecommendations || picked.indexOf(item) !== -1) return;
            if (!canAddRole(itemRole)) return;
            if (!canUseItemForRole(item, itemRole)) return;
            picked.push(item);
            markRole(itemRole);
            if (itemRole === currentRole && similarItems.length < (plan.similar || 0)) {
              similarItems.push(item);
            } else {
              completePicked.push(item);
            }
          });

          completeItems = completePicked.slice(0, Math.max(0, maxRecommendations - similarItems.length));
          selectedItems = similarItems.concat(completeItems).slice(0, maxRecommendations);
        }

        items.forEach(function(item) {
          item.hidden = true;
        });

        if (colorHandle && recommendationMode !== 'same_type') {
          addCandidates(function(item) {
            var handles = (item.getAttribute('data-color-handles') || '').split(/\s+/);
            var familyHandles = expandColorFamilies(handles);
            var sameType = item.getAttribute('data-product-type') === item.getAttribute('data-current-product-type');
            var allowedHandles = recommendationMode === 'same_color' ? siblingHandles : compatibleHandles;
            return !sameType && (firstMatchingHandle(handles, allowedHandles) || firstMatchingHandle(familyHandles, allowedHandles));
          });
        }

        if (colorHandle && recommendationMode !== 'different_type') {
          addCandidates(function(item) {
            var handles = (item.getAttribute('data-color-handles') || '').split(/\s+/);
            var familyHandles = expandColorFamilies(handles);
            var sameType = item.getAttribute('data-product-type') === item.getAttribute('data-current-product-type');
            return sameType && (firstMatchingHandle(handles, siblingHandles) || firstMatchingHandle(familyHandles, siblingHandles));
          });
        }

        if (recommendationMode === 'same_type') {
          addCandidates(function(item) {
            return item.getAttribute('data-product-type') === item.getAttribute('data-current-product-type');
          });
        }

        addCandidates(function(item) {
          if (recommendationMode === 'smart') return getRoleFromItem(item) !== 'other';
          return !colorHandle || selectedItems.length < maxRecommendations;
        });

        if (recommendationMode === 'smart') {
          sortByStylingScore();
          pickBySlots();
        }

        if (colorHandle && selectedItems.length < maxRecommendations) {
          items.forEach(function(item) {
            if (selectedItems.length >= maxRecommendations || selectedItems.indexOf(item) !== -1) return;
            if (avoidSeasonMismatch && !isSeasonCompatible(item)) return;
            if (!itemHasSelectedColorVariant(item, selectedColorHandle)) return;
            if (getRoleFromItem(item) === 'jewelry' && getCurrentRole(item) !== 'jewelry') return;

            selectedItems.push(item);
          });
        }

        if (grid) {
          selectedItems.slice(0, maxRecommendations).forEach(function(item) {
            grid.appendChild(item);
          });
        }

        selectedItems.slice(0, maxRecommendations).forEach(function(item) {
          var itemRole = getRoleFromItem(item);
          var handles = (item.getAttribute('data-color-handles') || '').split(/\s+/);
          var familyHandles = expandColorFamilies(handles);
          var exactMatch = colorHandle && (handles.indexOf(colorHandle) !== -1 || familyHandles.indexOf(normalizeColorFamily(colorHandle)) !== -1);
          var variantHandle = null;

          if (colorHandle && !itemHasSelectedColorVariant(item, selectedColorHandle)) return;

          if (
            itemRole === 'jewelry' &&
            getCurrentRole(item) !== 'jewelry' &&
            !itemHasJewelryColorAffinity(item, compatibleHandles.concat(siblingHandles), colorHandle)
          ) return;

          if (exactMatch) {
            variantHandle = firstMatchingActualHandle(handles, [selectedColorHandle, colorHandle]);
          }

          variantHandle = variantHandle ||
            firstMatchingActualHandle(handles, compatibleHandles) ||
            firstMatchingActualHandle(handles, siblingHandles);

          if (variantHandle) item.href = getVariantLink(item, variantHandle);
          item.hidden = false;
          item.setAttribute('data-jabotter-recommendation-group', similarItems.indexOf(item) !== -1 ? 'similar' : 'complete');
          if (exactMatch) exactVisible += 1;
          if (colorHandle && variantHandle) compatibleVisible += 1;
        });

        if (heading && !customHeading) {
          if (recommendationMode === 'same_type') {
            heading.textContent = 'Aynı stile yakın öneriler';
          } else {
            heading.textContent = 'Bu ürünü inceleyenlerin diğer tercihleri';
          }
        }
      }

      product.addEventListener('change', function(event) {
        if (event.target && event.target.matches('[data-single-option-selector]')) {
          window.requestAnimationFrame(updateRecommendations);
        }
      });

      product.addEventListener('click', function(event) {
        if (event.target && event.target.closest('label[data-swatch]')) {
          window.setTimeout(updateRecommendations, 80);
        }
      });

      block.addEventListener('click', function(event) {
        var item = event.target && event.target.closest('[data-jabotter-inline-color-item]');
        if (!item) return;

        var selectedColorHandle = normalizeColor(getSelectedColor());
        var handles = (item.getAttribute('data-color-handles') || '').split(/\s+/).map(normalizeColor).filter(Boolean);
        var variantHandle = firstMatchingActualHandle(handles, [selectedColorHandle]);

        if (!variantHandle && selectedColorHandle.indexOf('-') !== -1) {
          variantHandle = firstMatchingActualHandle(handles, [selectedColorHandle, normalizeColorFamily(selectedColorHandle)]);
        }

        if (!variantHandle) {
          event.preventDefault();
          updateRecommendations();
          return;
        }

        item.href = getVariantLink(item, variantHandle);
      }, true);

      updateRecommendations();
    });
  }

  function initProductRecommendationGuards() {
    if (!document.body.classList.contains('template-product')) return;

    var currentPath = window.location.pathname || '';
    var currentIsWinter = /(?:bot|cizme|çizme|boot|kis|kış)/i.test(decodeURIComponent(currentPath));
    var guardedSections = document.querySelectorAll('related-products, .section-recent-products, [data-section-type="related"]');

    function cardLooksWinter(card) {
      var text = [
        card.textContent || '',
        card.querySelector('a[href*="/products/"]') && card.querySelector('a[href*="/products/"]').getAttribute('href'),
      ].join(' ');

      return /(?:bot|cizme|çizme|boot|kis|kış)/i.test(decodeURIComponent(text));
    }

    function applyGuard(section) {
      var visibleCount = 0;
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-grid-item], .product-item'));

      cards.forEach(function(card) {
        var hideForSeason = !currentIsWinter && cardLooksWinter(card);
        var hideForLimit = visibleCount >= 6;

        card.hidden = hideForSeason || hideForLimit;
        card.classList.toggle('hidden', card.hidden);

        if (!card.hidden) visibleCount += 1;
      });
    }

    guardedSections.forEach(function(section) {
      applyGuard(section);

      new MutationObserver(function() {
        window.requestAnimationFrame(function() {
          applyGuard(section);
        });
      }).observe(section, { childList: true, subtree: true });
    });
  }

  function initCollectionFilteredVariantImages() {
    var params = new URLSearchParams(window.location.search);
    var selectedColor = params.get('filter.v.option.renk');
    if (!selectedColor) return;

    function normalizeValue(value) {
      return (value || '').toLocaleUpperCase('tr-TR').replace(/\s+/g, ' ').trim();
    }

    function applyFilteredColor() {
      var selected = normalizeValue(selectedColor);
      var cards = document.querySelectorAll('[data-grid-item]');

      cards.forEach(function(card) {
        var matchingSwatch = Array.prototype.find.call(card.querySelectorAll('[data-swatch]'), function(swatch) {
          return normalizeValue(swatch.getAttribute('data-swatch')) === selected;
        });

        if (matchingSwatch && matchingSwatch.href) {
          card.querySelectorAll('[data-product-link]').forEach(function(link) {
            link.setAttribute('href', matchingSwatch.href);
            link.setAttribute('data-product-link', matchingSwatch.href);
          });
        }

        card.setAttribute('data-jabotter-filtered-color', selected);
        card.querySelectorAll('[data-swatch]').forEach(function(swatch) {
          var isSelectedSwatch = normalizeValue(swatch.getAttribute('data-swatch')) === selected;
          swatch.style.pointerEvents = isSelectedSwatch ? '' : 'none';
          swatch.setAttribute('aria-disabled', isSelectedSwatch ? 'false' : 'true');
        });

        var matchingImage = Array.prototype.find.call(card.querySelectorAll('[data-variant-title]'), function(image) {
          var variantTitle = normalizeValue(image.getAttribute('data-variant-title'));
          return variantTitle === selected || variantTitle.indexOf(selected + ' /') === 0;
        });

        if (!matchingImage) return;

        card.querySelectorAll('[data-variant-title].is-visible').forEach(function(image) {
          image.classList.remove('is-visible');
        });
        matchingImage.classList.add('is-visible');

        if (matchingSwatch) {
          matchingSwatch.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
        }
      });
    }

    function keepFilteredColor(event) {
      var swatch = event.target && event.target.closest && event.target.closest('[data-swatch]');
      var card = event.target && event.target.closest && event.target.closest('[data-grid-item]');
      if (!card) return;

      if (swatch && normalizeValue(swatch.getAttribute('data-swatch')) !== normalizeValue(selectedColor)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      window.requestAnimationFrame(applyFilteredColor);
    }

    applyFilteredColor();

    ['mouseenter', 'mouseover', 'focusin', 'mouseleave'].forEach(function(eventName) {
      document.addEventListener(eventName, keepFilteredColor, true);
    });

    document.addEventListener('click', function(event) {
      var swatch = event.target && event.target.closest && event.target.closest('[data-swatch]');
      if (!swatch || normalizeValue(swatch.getAttribute('data-swatch')) === normalizeValue(selectedColor)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      applyFilteredColor();
    }, true);

    var collection = document.querySelector('[data-section-type="collection"], [data-collection]');
    if (collection) {
      new MutationObserver(function() {
        window.requestAnimationFrame(applyFilteredColor);
      }).observe(collection, { childList: true, subtree: true });
    }

    window.setTimeout(applyFilteredColor, 600);
    window.setTimeout(applyFilteredColor, 1600);
  }

  function initJabotterCustomEnhancements() {
    initMobileSiblingSwatches();
    initProductThumbNav();
    initInlineColorRecommendations();
    initProductRecommendationGuards();
    initCollectionFilteredVariantImages();
    scheduleCartTotalSync();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    new MutationObserver(scheduleCartTotalSync).observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJabotterCustomEnhancements);
  } else {
    initJabotterCustomEnhancements();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
